<template>
  <div class="followerRequestWrapper">
    <div class="followerRequestHeader">
      <div>이름</div>
      <div>성별</div>
      <div>나이</div>
      <div>직업</div>
      <div>지역</div>
      <div>승인</div>
    </div>
    <div class="followerRequestContentDiv">
      <div class="followerRequestContent" v-for="row in tableData.rows" v-bind:key="row.requestId">
        <div>{{row.nickname}}</div>
        <div>{{row.gender}}</div>
        <div>{{row.age}}</div>
        <div>{{row.job}}</div>
        <div>{{row.location}}</div>
        <div>
          <img class="followerRequestIcon" v-bind:src="acceptIcon" v-on:click="setAcceptance(row.requestId)">
          <img class="followerRequestIcon" v-bind:src="rejectIcon" v-on:click="setRejection(row.requestId)">
        </div>
      </div>
      <div class="followerRequestNoDataDiv" v-show="tableData.rows.length === 0">
        <span>팔로워 요청이 없습니다.</span>
      </div>
    </div>
    <div class="followerRequestFooter">
      <div class="pagePreviousDiv">
        <img class="pagePreviousIcon" v-show="isShowPreviousPagePointer" v-on:click="setShowPages(-10)" v-bind:src="pagePreviousIcon" />
      </div>
      <span class="page" v-for="index in showPageArray" v-bind:key="index" v-bind:class="{selectedPage: contentPageIndex === index}" v-on:click="getSelectedPageData(index)">{{index + 1}}</span>
      <div class="pageNextDiv">
        <img class="pageNextIcon" v-show="isShowNextPagePointer" v-on:click="setShowPages(10)" v-bind:src="pageNextIcon" />
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store'
import params from '../../../params.js'

export default {
  data () {
    return {
      acceptIcon: '',
      rejectIcon: '',
      districtList: null,
      jobList: params.job,
      tableData: {
        rows: []
      },
      contentPageIndex: 0,
      showPageArray: [],
      showPageArrayIndexStart: 0,
      isShowNextPagePointer: false,
      isShowPreviousPagePointer: false,
      totalPageNumber: 0,
      pagePreviousIcon: null,
      pageNextIcon: null
    }
  },
  methods: {
    setTableData: function (listData) {
      let rows = []
      for(var i = 0; i < listData.length; i++) {
        let gender
        if(listData[i].user.gender != null) {
          if (listData[i].user.gender === 'MALE') {
            gender = '남자'
          }else if (listData[i].user.gender === 'FEMALE') {
            gender = '여자'
          }else {
            gender = '성별모름'
          }
        }else {
          gender = '정보없음'
        }
        rows.push({
          requestId: listData[i].id,
          nickname: listData[i].user.nickname,
          gender: gender,
          age: listData[i].user.birthYear != null ? (new Date().getFullYear() + 1) - listData[i].user.birthYear + '세' : '정보없음',
          job: listData[i].user.job != null ? this.jobList.find(items => items.engText === listData[i].user.job).text : '정보없음',
          location: listData[i].user.districts.length !== 0 ? this.getLocationText(listData[i].user.districts) : '정보없음'
        })
      }
      this.tableData.rows = rows
    },
    setAllDistrictList: function (districtAllData) {
      this.districtList = JSON.parse(JSON.stringify(districtAllData))
    },
    getLocationText: function (districtIdList) {
      let locationText = ''
      for(var i = 0; i < districtIdList.length; i++) {
        let districtInfo = this.districtList.find(items => items.id === districtIdList[i])
        locationText += districtInfo.regionName + ' ' + districtInfo.name + ','
      }
      return locationText.substring(0, locationText.length - 1)
    },
    setAcceptance: async function (requestId) {
      try {
        await store.dispatch('followerAcceptanceApi', {requestId: requestId})
        // 데이터 제거
        let selectedData = this.tableData.rows.find(items => items.requestId === requestId)
        let idx = this.tableData.rows.indexOf(selectedData)
        if (idx > -1) {
          this.tableData.rows.splice(idx, 1)
        }
        // 팔로워 요청 카운트 셋팅
        this.setRequestCount(this.tableData.rows.length)
      }catch (error) {
        console.log(error.response)
      }
    },
    setRejection: async function (requestId) {
      try {
        await store.dispatch('followerRejectionApi', {requestId: requestId})
        // 데이터 제거
        let selectedData = this.tableData.rows.find(items => items.requestId === requestId)
        let idx = this.tableData.rows.indexOf(selectedData)
        if (idx > -1) {
          this.tableData.rows.splice(idx, 1)
        }
        // 팔로워 요청 카운트 셋팅
        this.setRequestCount(this.tableData.rows.length)
      }catch (error) {
        console.log(error.response)
      }
    },
    setPageInfo: function () {
      this.showPageArray = []
      if(this.totalPageNumber <= this.showPageArrayIndexStart + 10) {
        for (var i = this.showPageArrayIndexStart; i < this.totalPageNumber; i++) {
          this.showPageArray.push(i)
          this.isShowNextPagePointer = false
        }
      } else {
        // eslint-disable-next-line no-redeclare
        for (var i = this.showPageArrayIndexStart; i < this.showPageArrayIndexStart + 10; i++) {
          this.showPageArray.push(i)
        }
        this.isShowNextPagePointer = true
      }
      this.isShowPreviousPagePointer = this.showPageArrayIndexStart !== 0
    },
    getSelectedPageData: async function (selectedPageIndex) {
      this.contentPageIndex = selectedPageIndex
      try {
        let tableDataResponse = await store.dispatch('followerRequestApi', {pageIndex: selectedPageIndex})
        this.setTableData(tableDataResponse.data.data.content)
      } catch (error) {
        console.log(error.response)
      }
    },
    setShowPages: function (showPageNumber) {
      this.showPageArrayIndexStart += showPageNumber
      this.setPageInfo()
    },
    setRequestCount: function (count) {
      this.$emit('setRequestCount', count)
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let tableDataResponse = await store.dispatch('followerRequestApi', {pageIndex: 0})
      next(vm => {
        vm.totalPageNumber = tableDataResponse.data.data.totalPages
        vm.setRequestCount(tableDataResponse.data.data.totalElements)
        vm.setAllDistrictList(store.getters.getDistrictAllList)
        vm.setPageInfo(tableDataResponse.data.data)
        vm.setTableData(tableDataResponse.data.data.content)
      })
    }catch (error) {
      console.log(error.response)
    }
  },
  created: function () {
    this.acceptIcon = require('@/assets/img/follower_request_approval_icon.png')
    this.rejectIcon = require('@/assets/img/follower_request_delete_icon.png')
    this.pagePreviousIcon = require('@/assets/img/page_previous_icon.png')
    this.pageNextIcon = require('@/assets/img/page_next_icon.png')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.followerRequestWrapper{
  display : -webkit-flex;
  display : flex;
  flex-direction: column;
  background-color: white;
  margin: 0;
  padding: 0;
  flex: 1;
  overflow-y: auto;
}

.followerRequestHeader{
  display : -webkit-flex;
  display : flex;
  color: rgb(0,153,255);
  font-size: 11px;
  padding: 0 32px;
}

.followerRequestContentDiv{
  overflow-y: auto;
  flex: 1;
}

.followerRequestContent{
  display : -webkit-flex;
  display : flex;
  padding: 0 32px;
  font-size: 11px;
}

.followerRequestHeader > div:nth-child(n), .followerRequestContent >  div:nth-child(n){
  text-align: left;
  vertical-align: middle;
  padding: 15px 0 15px 25px;
  width: 93px;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerRequestHeader > div:first-child, .followerRequestContent >  div:first-child{
  padding: 15px 0 15px 25px;
  width: 93px;
}

.followerRequestHeader > div:nth-last-of-type(2), .followerRequestContent > div:nth-last-of-type(2){
  flex: auto;
}

.followerRequestHeader > div:last-child {
  text-align: center;
  width: 88px;
}

.followerRequestContent > div:last-child{
  display : -webkit-flex;
  display : flex;
  justify-content: center;
  align-items: center;
  width: 88px;
  padding: 0;
  border-bottom: rgb(172,172,172) solid 1px;
}

.followerRequestContent > div:last-child{
  align-items: center;
}

.followerRequestIcon{
  cursor: pointer;
  margin: 0 5px;
  height: 28px;
  width: auto;
}

.followerRequestFooter {
  text-align: center;
}

.pagePreviousDiv, .pageNextDiv {
  display: inline;
  vertical-align: middle;
}

.pagePreviousIcon, .pageNextIcon {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.page {
  cursor: pointer;
  text-decoration: underline;
  padding: 0 5px;
}

.selectedPage {
  font-weight: bold;
}

.followerRequestNoDataDiv {
  text-align: center;
  height: 100px;
  font-size: 11px;
  padding-top: 60px;
  color: #707070;
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/followerRequest.vue